import React from 'react';
import PropTypes from 'prop-types';
import { ContainerContactData, LeftSide, RightSide, LineContent } from './styles';

const ContactDataSkeleton = ({ device }) => {
  return (
    <>
      {device === 'desktop' && (
        <ContainerContactData>
          <LeftSide>
            <LineContent width='146px' />
            <LineContent height='48px' />
            <div className='separator' />
            <LineContent width='135px' />
            <LineContent width='146px' />
            <LineContent height='48px' />
            <LineContent width='331px' />
          </LeftSide>
          <RightSide>
            <LineContent width='146px' />
            <LineContent width='299px' />
            <LineContent height='112px' marginTop='16px' />
          </RightSide>
        </ContainerContactData>
      )}

      {device === 'tablet' && (
        <ContainerContactData>
          <LeftSide>
            <LineContent width='155px' height='16px' />
            <LineContent width='356px' height='48px' />
            <div className='separator' />
            <LineContent width='205px' height='16px' />
            <LineContent width='155px' height='16px' />
            <LineContent width='356px' height='48px' />
            <LineContent width='312px' height='16px' />
            <LineContent width='155px' height='16px' />
          </LeftSide>
          <RightSide>
            <LineContent width='155px' height='16px' />
            <LineContent width='299px' height='16px' />
            <LineContent width='356px' height='72px' marginTop='16px' />
          </RightSide>
        </ContainerContactData>
      )}

      {device === 'mobile' && (
        <ContainerContactData device={device}>
          <LeftSide device={device}>
            <LineContent width='155px' height='16px' />
            <LineContent width='328px' height='48px' marginBottom='26px' />
            <div className='separator' />
            <LineContent width='205px' height='16px' marginTop='26px' />
            <LineContent width='155px' height='16px' />
            <LineContent width='328px' height='48px' />
            <LineContent width='312px' height='16px' />
            <LineContent width='155px' height='16px' />
          </LeftSide>
          <RightSide device={device}>
            <LineContent width='155px' height='16px' />
            <LineContent width='312px' height='16px' />
            <LineContent width='328px' height='72px' marginTop='16px' />
          </RightSide>
        </ContainerContactData>
      )}
    </>
  );
};

ContactDataSkeleton.propTypes = {
  device: PropTypes.string.isRequired
};
export default ContactDataSkeleton;
